import { render, staticRenderFns } from "./EMColorPicker.vue?vue&type=template&id=03e8315e&scoped=true&"
import script from "./EMColorPicker.vue?vue&type=script&lang=js&"
export * from "./EMColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./EMColorPicker.vue?vue&type=style&index=0&id=03e8315e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e8315e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VCardText,VColorPicker,VMenu})
